import debounce from 'lodash/debounce';
import { useCallback, useEffect } from 'react';
import { useAdvancedEditorContext } from '../../context/useAdvancedEditorContext';
import { getPageProperty, PolotnoStoreActivePageKeys } from '../../hooks';

export const useUpdatePagesThumbnails = () => {
    const { store, createThumbnails } = useAdvancedEditorContext();

    const debouncedCreateThumbnails = useCallback(debounce(createThumbnails, 1000, { leading: false, trailing: true }), [createThumbnails]);

    useEffect(() => {
        const dispose = store.on('change', () => {
            void debouncedCreateThumbnails(store);
        });

        return () => {
            dispose();
        };
    }, [debouncedCreateThumbnails, store]);

    return store.pages.map(page => getPageProperty(page, PolotnoStoreActivePageKeys.thumbnail));
};
